import {useQuery} from "@tanstack/react-query";
import {regionsGet} from "../api/regions/regionsGet.ts";

export const useRegions = () => useQuery({
    queryKey: ['regions'],
    queryFn: () => regionsGet().then(r => r.payload)
})